import React from 'react';
import { Button } from '../../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import { HsmTemplate } from '../../../types';

export interface DeleteTemplateDialogProps {
  open: boolean;
  template: HsmTemplate | null;
  deleting: boolean;
  error: string | null;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteTemplateDialog({
  open,
  template,
  deleting,
  error,
  onOpenChange,
  onConfirm,
  onCancel,
}: DeleteTemplateDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(openState) => {
        if (!deleting) {
          onOpenChange(openState);
          if (!openState) {
            onCancel();
          }
        }
      }}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-red-600">Excluir Template</DialogTitle>
          <DialogDescription>
            Tem certeza que deseja excluir o template <strong>"{template?.name}"</strong>?
            <br />
            <br />
            <span className="text-red-500 font-medium">
              ATENCAO: Esta acao excluira permanentemente o template do WhatsApp/Meta Business
              Suite e nao pode ser desfeita.
            </span>
          </DialogDescription>
        </DialogHeader>

        {error && (
          <div className="rounded-lg border border-red-200 bg-red-50 dark:bg-red-900/20 dark:border-red-800 p-3">
            <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={deleting}>
            Cancelar
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={deleting}>
            {deleting ? 'Excluindo...' : 'Excluir Template'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
